import { Component, OnInit } from '@angular/core';
import { ProgressIndicatorService } from 'src/app/shared/progress-indicator/progress-indicator.service';

@Component({
  selector: 'app-copyright-shell',
  templateUrl: './copyright-shell.component.html',
  styleUrls: ['./copyright-shell.component.css']
})
export class CopyrightShellComponent implements OnInit {

  constructor( private _progressIndicatorService: ProgressIndicatorService) { }

  ngOnInit() {
    this._progressIndicatorService.show(false);
  }

}
